module.exports = __webpack_public_path__ + "static/media/ic-chevron-right-white.abd6929d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic-chevron-right-white.svg
// module id = 75
// module chunks = 0